/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
  toast: {
    disappearTimeoutInSeconds: 0,
    isShown: false,
    text: '',
    variant: 'error',
  },
};

export const utilSlice = createSlice({
  initialState,
  name: 'utilSlice',
  reducers: {
    reset: () => initialState,
    setToastConfig: (state, { payload }) => {
      state.toast = { ...payload };
    },
    setToastDisappearTimeoutInSeconds: (state, { payload }) => {
      state.toast.disappearTimeoutInSeconds = payload;
    },
    setToastIsShown: (state, { payload }) => {
      state.toast.isShown = payload;
    },
    setToastText: (state, { payload }) => {
      state.toast.text = payload;
    },
  },
});

export const utilSlicePersistedReducer = persistReducer(
  {
    key: 'utilSlice',
    storage,
  },
  utilSlice.reducer
);
